<template>
    <v-dialog v-model="dialog" max-width="1400">
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>Transaction Details</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-tabs slider-color="grey" v-model="activeTab">
                <v-tab ripple>Transaction</v-tab>
                <v-tab ripple>Payload</v-tab>

                <v-tab-item>
                    <v-container fluid grid-list-md class="transaction-tab">
                    <v-data-iterator :items="tableData" content-tag="v-layout" row wrap hide-actions>
                        <template v-slot:item="props">
                            
                            <v-flex xs6>
                            <v-hover>
                                <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 1}`">
                                    <v-list dense>
                                        <v-card-title class="primary white--text"><b>Transaction Information</b></v-card-title>
                                        <v-divider></v-divider>
                                        <v-list-tile v-if="props.item.amount">
                                            <v-list-tile-content class="font-weight-bold">Amount:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.amount }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Card Expiry:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.cardExpDate }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Card Holder:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.cardHolder }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Card Number:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.cardNumber }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.currency">
                                            <v-list-tile-content class="font-weight-bold">Currency:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.currency }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Date:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.processingTime }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.merchantTransactionId">
                                            <v-list-tile-content class="font-weight-bold">Merchant Transaction ID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.merchantTransactionId }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.paymentBrand">
                                            <v-list-tile-content class="font-weight-bold">Payment Brand:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.paymentBrand }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Payment Type:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.paymentType }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.recurringType">
                                            <v-list-tile-content class="font-weight-bold">Recurring Type:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.recurringType }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Status Description:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.resultDesc }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Status Code:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.resultCode }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Acquirer Response Code:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.acquirerResponseCode }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Extended Description:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.extendedDescription }}</v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-hover>
                            </v-flex>
                            
                            <v-flex xs6>
                            <v-hover>
                                <v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 1}`">
                                    <v-list dense>
                                        <v-card-title class="primary white--text"><b>Gateway Information</b></v-card-title>
                                        <v-divider></v-divider>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Channel ID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.channelId }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Channel Name:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.channelName }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile v-if="props.item.clearingInstitute">
                                            <v-list-tile-content class="font-weight-bold">Clearing Institute:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.clearingInstitute }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">DB ID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.dbId }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Merchant ID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.merchantId }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">Merchant Name:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.merchantName }}</v-list-tile-content>
                                        </v-list-tile>
                                        <v-list-tile>
                                            <v-list-tile-content class="font-weight-bold">UUID:</v-list-tile-content>
                                            <v-list-tile-content class="align-end">{{ props.item.uuid }}</v-list-tile-content>
                                        </v-list-tile>
                                    </v-list>
                                </v-card>
                            </v-hover>
                            </v-flex>
                        </template>
                    </v-data-iterator>
                    </v-container>

                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = false">Ok</v-btn>
                    </v-card-actions>
                </v-tab-item>
            
                <v-tab-item>
                    <v-card-text class="text-sm-left">
                        <pre>{{ json }}</pre>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="dialog = false">Ok</v-btn>
                    </v-card-actions>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data() {
            return {
                data: {},
                tableData: [],
                activeTab: 0,
                tableHeaders: [{ text: 'Status', value: 'status', sortable: false, align: 'center' },
                               { text: 'Date', value: 'date', sortable: false, align: 'left' },
                               { text: 'Payment Type', value: 'paymentType', sortable: false, align: 'left' },
                               { text: 'Amount', value: 'amount', sortable: false, align: 'left' },
                               { text: 'Currency', value: 'currency', sortable: false, align: 'left' },
                               { text: 'Status', value: 'status', sortable: false, align: 'left' }],
                json: null,
                currentDatetime: (new Date()).toISOString().slice(0, 19).replace("T", " ")
            }
        },
        props: {
            visible: Boolean,
            tranInfo: Object,
        },
        computed: {
            dialog: {
                get() {
                    if(this.visible) {
                        this.json = JSON.parse(this.tranInfo.json);
                        console.log(this.json);
                        this.data.amount = this.tranInfo.amount;
                        this.data.cardExpDate = `${this.tranInfo.expiryMonth} / ${this.tranInfo.expiryYear}`;
                        this.data.cardHolder = this.tranInfo.holder;
                        this.data.cardNumber = `${this.tranInfo.bin}******${this.tranInfo.last4Digits}`;
                        this.data.channelId = this.tranInfo.channelUuid;
                        this.data.channelName = this.tranInfo.channelName;
                        this.data.clearingInstitute = this.tranInfo.clearingInstitute;
                        this.data.code = this.tranInfo.resultCode;
                        this.data.currency = this.tranInfo.currency;
                        this.data.processingTime = this.tranInfo.processingTime;
                        this.data.dbId = this.tranInfo.id;
                        this.data.merchantId = this.tranInfo.merchantUuid;
                        this.data.merchantName = this.tranInfo.merchantName;
                        this.data.merchantTransactionId = this.tranInfo.merchantTransactionId;
                        this.data.paymentBrand = this.tranInfo.paymentBrand;
                        this.data.paymentType = this.tranInfo.paymentType;
                        this.data.references = this.references;
                        this.data.recurringType = this.tranInfo.recurringType;
                        this.data.refundAmount = this.tranInfo.amount;
                        this.data.resultCode = this.tranInfo.resultCode;
                        this.data.resultDesc = this.json.payload.result.description;
                        this.data.acquirerResponseCode = (this.json.payload.resultDetails || {}).AcquirerResponse || 'Empty';
                        this.data.extendedDescription = (this.json.payload.resultDetails || {}).ExtendedDescription || 'Empty';
                        this.data.uuid = this.tranInfo.uuid; 
                        this.tableData[0] = this.data;
                    }
                    return this.visible;
                },
                set(value) {
                    if(!value) {
                        this.activeTab = 0;
                        this.$emit('closeDialog');
                    }
                }
            }
        },
        methods: {
            
        }
    }
</script>